module.exports = __webpack_public_path__ + "static/media/stonewall_talarico_pic.5fa12caf.jpeg";